export enum EScriptStatus {
  IDLE = 'idle',
  LOADING = 'loading',
  ERROR = 'error',
  READY = 'ready',
}

export interface IUseScript {
  status: EScriptStatus;
  load: () => void;
}
